export enum AdminPageInternalActionTypes {
  UPDATED_SUCCESS = 'page/UPDATED_SUCCESS',
  UPDATED_ERROR = 'page/UPDATED_ERROR',
  UPDATED_REQUEST = 'page/UPDATED_REQUEST',
}
